export enum SupportTicketPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  CRITICAL = "CRITICAL",
  URGENT = "URGENT",
}

export enum SupportTicketStatus {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  WAITING_FOR_CUSTOMER = "WAITING_FOR_CUSTOMER",
  CLOSED = "CLOSED",
  RESOLVED = "RESOLVED",
}